import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { MultipleChoiceAnswerReport } from '../answer-report';
import { QuestionReport } from './question-report';
export var MultipleChoiceQuestionReport = /*#__PURE__*/function (_QuestionReport) {
  _inherits(MultipleChoiceQuestionReport, _QuestionReport);

  var _super = _createSuper(MultipleChoiceQuestionReport);

  function MultipleChoiceQuestionReport() {
    _classCallCheck(this, MultipleChoiceQuestionReport);

    return _super.apply(this, arguments);
  }

  _createClass(MultipleChoiceQuestionReport, [{
    key: "correctAnswerPercentage",
    get: function get() {
      return this.props.correctAnswerPercentage;
    }
  }, {
    key: "totalCorrectAnswers",
    get: function get() {
      return this.props.totalCorrectAnswers;
    }
  }, {
    key: "wrongAnswerPercentage",
    get: function get() {
      return this.props.wrongAnswerPercentage;
    }
  }, {
    key: "totalWrongAnswers",
    get: function get() {
      return this.props.totalWrongAnswers;
    }
  }, {
    key: "answerReports",
    get: function get() {
      return this.props.answerReports;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.correctAnswerPercentage,
        argumentName: 'Correct Answer Percentage'
      }, {
        argument: props.wrongAnswerPercentage,
        argumentName: 'Wrong Answer Percentage'
      }, {
        argument: props.totalWrongAnswers,
        argumentName: 'Total Wrong Answers'
      }, {
        argument: props.answerReports,
        argumentName: 'Answer Reports'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new MultipleChoiceQuestionReport(props, new UniqueEntityID(props.id.toString())));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var correctAnswerPercentage = data.correctAnswerPercentage,
            totalCorrectAnswers = data.totalCorrectAnswers,
            wrongAnswerPercentage = data.wrongAnswerPercentage,
            totalWrongAnswers = data.totalWrongAnswers,
            answerReports = data.answerReports;

        var basePropsOrError = _get(_getPrototypeOf(MultipleChoiceQuestionReport), "createBaseProps", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var baseProps = basePropsOrError.getValue();

        var multipleChoiceAnswerReportProps = _toConsumableArray(answerReports);

        var multipleChoiceAnswerReportsOrError = multipleChoiceAnswerReportProps === null || multipleChoiceAnswerReportProps === void 0 ? void 0 : multipleChoiceAnswerReportProps.map(function (answerReport) {
          return MultipleChoiceAnswerReport.fromJson(answerReport);
        });
        var multipleChoiceAnswerReportResultOrErrorCombined = Result.combineArray(multipleChoiceAnswerReportsOrError);
        if (multipleChoiceAnswerReportResultOrErrorCombined.isFailure) return Result.fail(multipleChoiceAnswerReportResultOrErrorCombined.error);
        var multipleChoicenswerReports = multipleChoiceAnswerReportResultOrErrorCombined.getValue();
        var multipleChoiceQuestionReportOrError = this.create(_objectSpread(_objectSpread({}, baseProps), {}, {
          correctAnswerPercentage: correctAnswerPercentage,
          totalCorrectAnswers: totalCorrectAnswers,
          wrongAnswerPercentage: wrongAnswerPercentage,
          totalWrongAnswers: totalWrongAnswers,
          answerReports: multipleChoicenswerReports
        }));

        if (multipleChoiceQuestionReportOrError.isFailure) {
          return Result.fail(multipleChoiceQuestionReportOrError.error);
        }

        var multipleChoiceQuestionReport = multipleChoiceQuestionReportOrError.getValue();
        return Result.ok(multipleChoiceQuestionReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MultipleChoiceQuestionReport;
}(QuestionReport);